module.exports = __webpack_public_path__ + "static/media/logo1.353d60b6.png";